import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeEntry.vue'
import CoursesView from '../views/Courses.vue'
import CourseDetailView from '../views/CourseDetail.vue'
import LoginView from '../views/Login.vue'
import RegisterView from '../views/Register.vue'
import ResetPasswordView from '../views/ResetPassword.vue'
import ProfileView from '../views/Profile.vue'
import StudyHistoryView from '../views/StudyHistory.vue'
import CloudDriveInviteView from '../views/CloudDriveInvite.vue'
import CloudDriveListView from '../views/CloudDriveList.vue'
import CloudDriveFilesView from '../views/CloudDriveFiles.vue'
import CourseProgressView from '../views/CourseProgress.vue'
import CourseProcessView from '../views/CourseProcess.vue'
import ExamView from '../views/Exam.vue'
import ExamResultView from '../views/ExamResult.vue'
import ExamHistoryView from '../views/ExamHistory.vue'
import ScoreAnalysisView from '../views/ScoreAnalysis.vue'
import TextbookView from '../views/Textbook.vue'
import KnowledgeGraphView from '../views/KnowledgeGraph.vue'
import NotificationsView from '../views/Notifications.vue'
import StudyGroupsView from '../views/StudyGroups.vue'
import { isAuthenticated } from '../store/session'

const VideoPlayerView = () => import('../views/VideoPlayer.vue')
const PptPreviewView = () => import('../views/PptPreview.vue')
const MaterialShareView = () => import('../views/MaterialShare.vue')
const ProjectionPairView = () => import('../views/ProjectionPair.vue')
const HomeworkListView = () => import('../views/HomeworkList.vue')
const HomeworkDetailView = () => import('../views/HomeworkDetail.vue')
const HomeworkResultView = () => import('../views/HomeworkResult.vue')
const CourseEnrollmentView = () => import('../views/CourseEnrollment.vue')
const SelfTestListView = () => import('../views/SelfTestList.vue')
const SelfTestExamView = () => import('../views/SelfTestExam.vue')
const SelfTestResultView = () => import('../views/SelfTestResult.vue')
const SmartDocumentReaderView = () => import('../views/SmartDocumentReader.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/courses',
    name: 'courses',
    component: CoursesView,
    meta: {
      title: '课程中心'
    }
  },
  {
    path: '/courses/:id',
    name: 'course-detail',
    component: CourseDetailView,
    props: (route) => ({
      courseId: Number(route.params.id) || 0
    }),
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/video/:kejie/:course_id/:chapter_id',
    name: 'video-player',
    component: VideoPlayerView,
    meta: {
      title: '视频播放',
      requiresAuth: true
    }
  },
  {
    path: '/ppt',
    name: 'ppt-preview',
    component: PptPreviewView,
    meta: {
      title: 'PPT 预览'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: '会员登录',
      guestOnly: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: {
      title: '会员注册',
      guestOnly: true
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView,
    meta: {
      title: '重置密码',
      guestOnly: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: {
      title: '个人中心',
      requiresAuth: true
    }
  },
  {
    path: '/study-history',
    name: 'study-history',
    component: StudyHistoryView,
    meta: {
      title: '学习历史',
      requiresAuth: true
    }
  },
  {
    path: '/cloud-drive/invite',
    name: 'cloud-drive-invite',
    component: CloudDriveInviteView,
    meta: {
      title: '加入共享云盘'
    }
  },
  {
    path: '/cloud-drive',
    name: 'cloud-drive-list',
    component: CloudDriveListView,
    meta: {
      title: '我的共享云盘',
      requiresAuth: true
    }
  },
  {
    path: '/cloud-drive/:spaceId/files',
    name: 'cloud-drive-files',
    component: CloudDriveFilesView,
    meta: {
      title: '云盘文件',
      requiresAuth: true
    }
  },
  {
    path: '/courses/:id/progress',
    name: 'course-progress',
    component: CourseProgressView,
    props: (route) => ({
      courseId: Number(route.params.id) || 0
    }),
    meta: {
      title: '学习进度',
      requiresAuth: true
    }
  },
  {
    path: '/courses/:id/process',
    name: 'course-process',
    component: CourseProcessView,
    props: (route) => ({
      courseId: Number(route.params.id) || 0
    }),
    meta: {
      title: '教学流程',
      requiresAuth: true
    }
  },
  {
    path: '/courses/:id/enrollment',
    name: 'course-enrollment',
    component: CourseEnrollmentView,
    props: (route) => ({
      courseId: Number(route.params.id) || 0
    }),
    meta: {
      title: '课程学员',
      requiresAuth: true
    }
  },
  {
    path: '/courses/:courseId/homework',
    name: 'homework-list',
    component: HomeworkListView,
    props: (route) => ({
      courseId: Number(route.params.courseId) || 0
    }),
    meta: {
      title: '课程作业',
      requiresAuth: true
    }
  },
  {
    path: '/courses/:courseId/self-test',
    redirect: (to) => ({
      name: 'self-test-list',
      query: {
        course_id: to.params.courseId
      }
    })
  },
  {
    path: '/self-test',
    name: 'self-test-list',
    component: SelfTestListView,
    props: (route) => ({
      courseId: Number(route.query.course_id) || 0
    }),
    meta: {
      title: '课程自测',
      requiresAuth: true
    }
  },
  {
    path: '/self-test/:paperId',
    name: 'self-test-exam',
    component: SelfTestExamView,
    props: (route) => ({
      paperId: Number(route.params.paperId) || 0
    }),
    meta: {
      title: '开始自测',
      requiresAuth: true
    }
  },
  {
    path: '/self-test/result/:recordId',
    name: 'self-test-result',
    component: SelfTestResultView,
    props: (route) => ({
      recordId: Number(route.params.recordId) || 0
    }),
    meta: {
      title: '自测结果',
      requiresAuth: true
    }
  },
  {
    path: '/homework/:homeworkId',
    name: 'homework-detail',
    component: HomeworkDetailView,
    props: (route) => ({
      homeworkId: Number(route.params.homeworkId) || 0
    }),
    meta: {
      title: '作业详情',
      requiresAuth: true
    }
  },
  {
    path: '/homework/result/:recordId',
    name: 'homework-result',
    component: HomeworkResultView,
    props: (route) => ({
      recordId: Number(route.params.recordId) || 0
    }),
    meta: {
      title: '作业结果',
      requiresAuth: true
    }
  },
  {
    path: '/exam/:processExamId',
    name: 'exam',
    component: ExamView,
    props: (route) => ({
      processExamId: Number(route.params.processExamId) || 0
    }),
    meta: {
      title: '在线考试',
      requiresAuth: true
    }
  },
  {
    path: '/exam/result/:recordId',
    name: 'exam-result',
    component: ExamResultView,
    props: (route) => ({
      recordId: Number(route.params.recordId) || 0
    }),
    meta: {
      title: '考试结果',
      requiresAuth: true
    }
  },
  {
    path: '/exam/analysis/:recordId',
    name: 'score-analysis',
    component: ScoreAnalysisView,
    props: (route) => ({
      recordId: Number(route.params.recordId) || 0
    }),
    meta: {
      title: '成绩分析',
      requiresAuth: true
    }
  },
  {
    path: '/exam-history',
    name: 'exam-history',
    component: ExamHistoryView,
    meta: {
      title: '考试历史',
      requiresAuth: true
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsView,
    meta: {
      title: '站内信',
      requiresAuth: true
    }
  },
  {
    path: '/study-groups',
    name: 'study-groups',
    component: StudyGroupsView,
    meta: {
      title: '学习小组',
      requiresAuth: true
    }
  },
  {
    path: '/textbook/:id/read',
    name: 'textbook-smart-reader',
    component: SmartDocumentReaderView,
    props: (route) => ({
      textbookId: Number(route.params.id) || 0
    }),
    meta: {
      title: '智能阅读',
      requiresAuth: true
    }
  },
  {
    path: '/textbook/:id',
    name: 'textbook',
    component: TextbookView,
    props: (route) => ({
      textbookId: Number(route.params.id) || 0
    }),
    meta: {
      title: '电子教材',
      requiresAuth: true
    }
  },
  {
    path: '/knowledge-graph/:courseId',
    name: 'knowledge-graph',
    component: KnowledgeGraphView,
    props: (route) => ({
      courseId: Number(route.params.courseId) || 0
    }),
    meta: {
      title: '知识图谱',
      requiresAuth: true
    }
  },
  {
    path: '/material/share',
    name: 'material-share',
    component: MaterialShareView,
    meta: {
      title: '资料分享'
    }
  },
  {
    path: '/projection/pair',
    name: 'projection-pair',
    component: ProjectionPairView,
    meta: { title: '投屏控制' }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  const requiresTextbookPptAuth = to.name === 'ppt-preview' && Number(to.query.textbook_id) > 0
  if ((to.matched.some((record) => record.meta.requiresAuth) || requiresTextbookPptAuth) && !isAuthenticated()) {
    next({
      name: 'login',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }

  if (to.matched.some((record) => record.meta.guestOnly) && isAuthenticated()) {
    next({ name: 'profile' })
    return
  }

  next()
})

router.afterEach((to) => {
  const title = to.meta.title ? `${to.meta.title} | Course Space` : 'Course Space'

  document.title = title
})

export default router
